(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lb-accessibility-repairs"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const syncSlides = (root) => {
      if (root.matches?.('.slick-slide[aria-hidden]')) root.inert = root.getAttribute('aria-hidden') === 'true';
      root.querySelectorAll?.('.slick-slide[aria-hidden]').forEach(slide => {
        slide.inert = slide.getAttribute('aria-hidden') === 'true';
      });
    };
    syncSlides(document);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') syncSlides(record.target);
        else record.addedNodes.forEach(syncSlides);
      }
    }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']});

    const drawer = document.getElementById('halo-cart-sidebar');
    if (!drawer) return;
    const close = drawer.querySelector('[data-close-cart-sidebar]');
    const status = document.getElementById('lb-cart-status');
    const inerted = new Set();
    let opened = false;
    let suspended = false;
    let opener = null;
    let lastFocus = null;
    let lastControl = null;
    const visible = element => Boolean(element?.isConnected && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]'));
    const controls = () => [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')].filter(element => element.tabIndex >= 0 && !element.disabled && visible(element));
    const release = () => {
      inerted.forEach(element => { element.inert = false; });
      inerted.clear();
    };
    const isolate = () => {
      let current = drawer;
      while (current.parentElement) {
        for (const sibling of current.parentElement.children) {
          if (sibling !== current && !sibling.inert && !sibling.matches('script, style, link, .background-overlay')) {
            sibling.inert = true;
            inerted.add(sibling);
          }
        }
        current = current.parentElement;
        if (current === document.body) break;
      }
    };
    const focusFirst = () => (controls()[0] || drawer).focus({preventScroll: true});
    const focusOnOpen = () => {
      let frames = 0;
      const ready = () => {
        if (!opened || suspended) return;
        if (visible(close)) close.focus({preventScroll: true});
        else if (++frames < 90) requestAnimationFrame(ready);
      };
      requestAnimationFrame(ready);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-cart-sidebar], [data-btn-addtocart]');
      if (trigger && !drawer.contains(trigger)) opener = trigger;
    }, true);
    document.addEventListener('focusin', event => {
      if (!opened || suspended) return;
      if (!drawer.contains(event.target)) {
        focusFirst();
        return;
      }
      lastFocus = event.target;
      const quantity = event.target.closest('quantity-input, cart-quantity, .previewCartItem')?.querySelector('[data-cart-quantity]');
      lastControl = {id: event.target.id, line: quantity?.dataset.line, kind: event.target.matches('.plus') ? 'plus' : event.target.matches('.minus') ? 'minus' : 'input'};
    });
    const syncDrawer = () => {
      const nowOpen = document.body.classList.contains('cart-sidebar-show');
      const nested = ['quickshop-popup-show', 'quick_shop_popup_mobile', 'edit-cart-show', 'term-condition-show', 'has-warning'].some(name => document.body.classList.contains(name));
      if (nowOpen && !opened) {
        if (!visible(opener)) opener = document.activeElement;
        opened = true;
        drawer.inert = false;
        suspended = nested;
        if (!nested) {
          isolate();
          focusOnOpen();
        }
      } else if (!nowOpen && opened) {
        opened = false;
        release();
        if (visible(opener)) opener.focus({preventScroll: true});
        drawer.inert = true;
        lastFocus = null;
        lastControl = null;
      } else if (opened && suspended !== nested) {
        suspended = nested;
        if (nested) release();
        else {
          requestAnimationFrame(() => {
            if (!opened || suspended) return;
            isolate();
            if (visible(lastFocus)) lastFocus.focus({preventScroll: true});
            else focusOnOpen();
          });
        }
      }
    };
    new MutationObserver(syncDrawer).observe(document.body, {attributes: true, attributeFilter: ['class']});
    document.addEventListener('keydown', event => {
      if (!opened || suspended) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        close.click();
      } else if (event.key === 'Tab') {
        const elements = controls();
        const first = elements[0] || drawer;
        const last = elements[elements.length - 1] || drawer;
        if (!drawer.contains(document.activeElement) || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last) || !elements.length) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    }, true);
    const content = drawer.querySelector('.previewCart-wrapper');
    if (content) new MutationObserver(() => {
      if (!opened || suspended) return;
      if (lastFocus && !lastFocus.isConnected) {
        const sameId = lastControl?.id ? document.getElementById(lastControl.id) : null;
        const quantity = [...content.querySelectorAll('[data-cart-quantity]')].find(input => input.dataset.line === lastControl?.line);
        const replacement = sameId || (lastControl?.kind === 'input' ? quantity : quantity?.parentElement.querySelector('.' + lastControl?.kind));
        if (visible(replacement)) replacement.focus({preventScroll: true});
        else if (!drawer.contains(document.activeElement)) focusFirst();
      }
      if (status && !content.querySelector('.loading-overlay')) {
        const count = drawer.querySelector('.wrapper-cartCount')?.textContent.trim();
        const total = content.querySelector('.previewCartTotals')?.textContent.trim();
        const text = [count, total].filter(Boolean).join('. ');
        if (status.textContent !== text) status.textContent = text;
      }
    }).observe(content, {childList: true, subtree: true});
    syncDrawer();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
